import helloWorld from "./scripts/helloWorld";

helloWorld();
